/** Chemin canonique offre — aligné sur backend seo_service.offer_public_path */
export function getOfferCanonicalPath(offer) {
  if (!offer || typeof offer !== 'object') return null;

  const slug = offer.slug || offer.bundle_slug;
  if (slug) {
    let category =
      offer.primary_category ||
      offer.slugCategory ||
      offer.category;
    if (Array.isArray(category)) {
      category = category[0];
    }
    if (!category && Array.isArray(offer.categories) && offer.categories.length) {
      category = offer.categories[0];
    }
    const normSlug = String(slug).trim().replace(/^\/+|\/+$/g, '');
    if (category) {
      const normCat = String(category).trim().replace(/^\/+|\/+$/g, '');
      return `/${normCat}/${normSlug}`;
    }
    return `/${normSlug}`;
  }

  const offerId = offer.id;
  if (offerId != null && !String(offerId).startsWith('bundle:')) {
    return `/offer/${offerId}`;
  }
  return null;
}

export default getOfferCanonicalPath;
